
export default class ParseUtils {

    public static coalesceFloat(rawNum) {
        const parsed = parseFloat(rawNum);
        return isNaN(parsed) ? 0 : parsed;
    }

}